export default __webpack_public_path__ + "static/media/adn2.16fbaba0.png";